/* app/js/src/components/common/search-input-dumb/search-input-dumb.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.input-wrapper {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background-color: #ffffff;
  padding: 5px 9px;
  border-radius: 5px;
}
.input-wrapper input {
  border: none;
  background: none;
  font-size: 0.8em;
  color: #232f3a;
  -webkit-flex: 15 0 0;
  -ms-flex: 15 0 0;
  flex: 15 0 0;
}
.input-wrapper input:focus {
  outline: none;
}
.input-wrapper input::selection {
  background-color: #232f3a;
  color: #ffffff;
}
.input-wrapper input::-moz-selection {
  background-color: #232f3a;
  color: #ffffff;
}
.input-wrapper i {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  cursor: pointer;
}
.input-wrapper i svg {
  fill: #879baf;
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.input-wrapper i:active svg {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  fill: #232f3a;
}
.input-wrapper ::-webkit-input-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
.input-wrapper :-moz-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
.input-wrapper ::-moz-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
.input-wrapper :-ms-input-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
.search-history {
  background-color: white;
  flex-basis: 200px;
  position: absolute;
  width: 258px;
  border-radius: 4px;
  z-index: 5;
  margin-top: 5px;
  overflow: hidden;
  display: none;
  opacity: 0;
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  -webkit-box-shadow: 0 0 10px 0 #d3d3d3;
  -moz-box-shadow: 0 0 10px 0 #d3d3d3;
  box-shadow: 0 0 10px 0 #d3d3d3;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-transition: all 80ms cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 80ms cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
.search-history.visible {
  -ms-transform: translateY(0px);
  -webkit-transform: translateY(0px);
  transform: translateY(0px);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  opacity: 1;
}
.search-history .search-item {
  opacity: 0;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 100ms;
  -webkit-animation-name: fadeInFromLeft;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 100ms;
  -moz-animation-name: fadeInFromLeft;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 100ms;
  -o-animation-name: fadeInFromLeft;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 100ms;
  animation-name: fadeInFromLeft;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
.search-history .search-item:nth-of-type(1) {
  -webkit-animation-delay: 20ms;
  animation-delay: 20ms;
}
.search-history .search-item:nth-of-type(2) {
  -webkit-animation-delay: 40ms;
  animation-delay: 40ms;
}
.search-history .search-item:nth-of-type(3) {
  -webkit-animation-delay: 60ms;
  animation-delay: 60ms;
}
.search-history .search-item:nth-of-type(4) {
  -webkit-animation-delay: 80ms;
  animation-delay: 80ms;
}
.search-history .search-item:nth-of-type(5) {
  -webkit-animation-delay: 100ms;
  animation-delay: 100ms;
}
.search-history .search-item:nth-of-type(6) {
  -webkit-animation-delay: 120ms;
  animation-delay: 120ms;
}
.search-history .search-item:nth-of-type(7) {
  -webkit-animation-delay: 140ms;
  animation-delay: 140ms;
}
.search-history .search-item:nth-of-type(8) {
  -webkit-animation-delay: 160ms;
  animation-delay: 160ms;
}
.search-history .search-item:nth-of-type(9) {
  -webkit-animation-delay: 180ms;
  animation-delay: 180ms;
}
.search-history .search-item:nth-of-type(10) {
  -webkit-animation-delay: 200ms;
  animation-delay: 200ms;
}
.search-history .search-item:nth-of-type(11) {
  -webkit-animation-delay: 220ms;
  animation-delay: 220ms;
}
.search-history .search-item:hover {
  color: black;
  background-color: #eef2f6;
  cursor: pointer;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
li {
  border-bottom: 1px solid #eef2f6;
  width: 100%;
  font-family: Open Sans;
  font-size: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  color: #7d8fa1;
  text-overflow: ellipsis;
}
.header-history {
  color: black;
  padding-left: 10px;
  font-weight: bold;
}
/*# sourceMappingURL=search-input-dumb.component.css.map */
